// ボスの致命 (とどめ) 固有の音と、花嫁の抱擁が決まった時の「ぎゅーっ」(2026-11-01・音の専用セッション)。
//   記録 = docs/research/2026-11-01-sfx-pass3.md (介錯・覚醒獣・抱擁の1版目) → docs/research/2026-11-01-sfx-finisher-all.md (残りのボスと抱擁の作り直し)
//   作者原文 (11-01)「ボスの致命攻撃はそれぞれ特有の音を設定したい」
//             「花嫁に関しては、掴み攻撃の時のつかみに成功してハートが出ている時にぎゅーって抱きしめている効果音が欲しい」
//   作者の答え (11-01)：介錯・覚醒獣の音は ok・残りのボスへ広げる・抱擁の1版目は「この音ではない」。
//   致命の音は被弾音 (hit_player・主人公の痛み) に重ねる。配布版で鳴る。開発版 ?finisherSfx=off で前 (被弾音だけ)。
//   騎士・鶏・剣舞は前から自分の致命の音 (exec_unique_sound.ts の knight_exec_impact・bsfx_v1_rooster_exec・bsfx_v1_blade_exec) を持つので重ねない。
//   軍配者たちは二人の戦い (twins_fight.ts) に致命が無いので音も無い。
//   抱擁の音は作者が C「重い愛」を選んだ (11-01 hug2＝c)。既定 = C。開発版 ?brideHugSfx=a|b で他の案、=v1 で1版目、=off で無音。
//   素材 = LUNAIRE-notes/assets/2026-10-30-exec-sfx-tools/scripts/render_finisher_1101.py と render_finisher_all_1101.py (Surge XT) → public/sfx/fin_sfx_<名前>.wav。
//   名前が fin_sfx_ で始まる音はボスの技の音として下げない (被弾の束と同じ瞬間に鳴る・src/sound_priority.ts の isBossMoveSfx に入れない)。
import type { SfxId } from './types'

export const FINISHER_SFX_NAMES = [
  'executioner', 'awoken', 'shade', 'hound', 'bride', 'princess',
  'bride_hug', 'bride_hug_a', 'bride_hug_b', 'bride_hug_c',
  // 11-01 雑音の仕上げ直し (頭尾のフェード・DC 除去・高域の丸め) の前の版。開発版 ?finisherSfx=v1
  'executioner_v1', 'awoken_v1', 'shade_v1', 'hound_v1', 'bride_v1', 'princess_v1', 'bride_hug_c_v1',
] as const
export type FinisherSfxName = typeof FINISHER_SFX_NAMES[number]
export const FINISHER_SFX_IDS = FINISHER_SFX_NAMES.map(n => `fin_sfx_${n}` as const)

// 致命の攻撃 → 音。載っていない攻撃は今まで通り (被弾音だけ)。
const FINISHER: Readonly<Record<string, FinisherSfxName>> = {
  executioner_finisher: 'executioner',
  kingExecutionAwoken: 'awoken',
  shadeExecution: 'shade',
  houndExecution: 'hound',
  brideExecution: 'bride',
  princessExecution: 'princess',
}

const HUG: Readonly<Record<string, FinisherSfxName>> = { v1: 'bride_hug', a: 'bride_hug_a', b: 'bride_hug_b', c: 'bride_hug_c' }

let finishersOn = true
let oldMix = false
const HUG_DEFAULT: FinisherSfxName = 'bride_hug_c'
let hug: FinisherSfxName | null = HUG_DEFAULT
export function setFinisherSfx(value: string | null | undefined): boolean {
  finishersOn = value !== 'off'
  oldMix = value === 'v1'
  return finishersOn
}
export function setBrideHugSfx(value: string | null | undefined): FinisherSfxName | null {
  hug = value === 'off' ? null : (value && HUG[value]) || HUG_DEFAULT
  return hug
}
const pick = (n: FinisherSfxName): SfxId => (oldMix && (FINISHER_SFX_NAMES as readonly string[]).includes(`${n}_v1`) ? `fin_sfx_${n}_v1` : `fin_sfx_${n}`) as SfxId

/** 致命が当たった瞬間に重ねる音。null = 被弾音だけ。 */
export function finisherImpactSfx(attackId: string): SfxId | null {
  const n = finishersOn ? FINISHER[attackId] : undefined
  return n ? pick(n) : null
}
/** 掴みが決まった瞬間の音 (花嫁の抱擁だけ)。null = 鳴らさない。 */
export function grabStartSfx(bossId: string, attackId: string): SfxId | null {
  return hug && bossId === 'bride' && attackId === 'vowEmbrace' ? pick(hug) : null
}

export function finisherSfxFiles(): [string, string][] {
  return FINISHER_SFX_IDS.map(k => [k, `/sfx/${k}.wav?v=3`])
}
